import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _IncomeResponsible } from "../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { IncomeResponsibleConcept } from "../IncomeResponsibleConcept/IncomeResponsibleConcept";



export const IncomeResponsible = () => {

    const income = useDataBean(_IncomeResponsible);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalresp, setModalresp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        income.instance.getIncomeResponsibleCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        income.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        income.deleteItemVoid(income.bean.IDIncomeResponsible).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        income.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDIncomeResponsible', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Responsable', property: 'AccountName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Area Funcional', property: 'FunctionalIDName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Conceptos de Detalle de Ingresos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalresp({ ...modalresp, "name": ``, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${income.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Responsables de Detalle por Compensación de Ingresos Tesorería">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={income.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={income.bean.Name} onChange={income.handleChange} />

                            </div>
                            <div className="col-md-12">
                                <AccountEditor label="Responsable" idAccount={income.bean.IDAccount} onChange={(e: any) => { income.setBean({ ...income.bean, "IDAccount": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalID functionalIDLn={income.bean.IDLnFunctionalID} onChange={(e: any) => { income.setBean({ ...income.bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={income.bean.Code} onChange={income.handleChange} />
                            </div>

                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={income.bean.Description} onChange={income.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalresp} updateModal={setModalresp} eventModal={editaItem}>
                        <div className="row">
                            <IncomeResponsibleConcept IncomeResponsible={income.bean.IDIncomeResponsible} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {income.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}